module.exports = __webpack_public_path__ + "static/media/essorLogo.e7fb20f3.png";